module.exports = __webpack_public_path__ + "img/god-ape-quest-map.f1616ffd.png";